import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./auth.css";
import api from "../api";

export default function RegisterPage() {
  const navigate = useNavigate();

  const [fullName, setFullName] = useState("");
  const [consentFile, setConsentFile] = useState(null);
  const [agreed, setAgreed] = useState(false);

  // Registration access is now handled by RegisteredUserRoute
  // This component only handles the registration form

  const handleSubmit = async () => {
    if (!fullName || !agreed || !consentFile) {
      alert("Please fill all fields, upload consent form, and agree to terms.");
      return;
    }

    const formData = new FormData();
    formData.append("fullName", fullName);
    formData.append("agreedToTerms", agreed.toString());
    formData.append("consentFile", consentFile);
    console.log("Full name:", fullName);
    console.log("Agreed to terms:", agreed);
    console.log("Consent file:", consentFile);

    const token = localStorage.getItem("token");
    try {
      await api.post("/register", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      alert("Registration complete!");
      navigate("/profile");
    } catch (err) {
      console.error(err);
      alert("Registration failed.");
    }
  };

  return (
    <div className="register-form">
      <h2>Complete Your Registration</h2>

      <label>Full Name</label>
      <input value={fullName} onChange={(e) => setFullName(e.target.value)} required />

      <h3>Download and sign the consent form</h3>
      <button className="consent-button"><a
        href="https://1drv.ms/b/c/75d03429d4bc19e1/EWRSkKu-FxJJofPPllR40TMB8yvijJJigLPbnULS1fksGA?e=gvPPGg"
        target="_blank"
        rel="noreferrer"
      >
        Download Consent Form
      </a> </button>

      <h3>Upload Signed Consent Form</h3>
      <input
        type="file"
        accept="application/pdf"
        onChange={(e) => setConsentFile(e.target.files[0])}
      />

      <div>
        <input
          type="checkbox"
          className="terms-check"
          checked={agreed}
          onChange={(e) => setAgreed(e.target.checked)}
        />
        <span>
          I agree to the <a href="/terms" target="_blank">Terms and Conditions</a> &{" "}
          <a href="/privacy" target="_blank">Privacy Policy</a>
        </span>
      </div>

      <button onClick={handleSubmit}>Submit</button>
    </div>
  );
}
